import { InfoCircleOutlined } from "@ant-design/icons";
import { Collapse, Divider, Tag, Typography } from "antd";
import React from "react";
import QuickDocs from "../../../QuickDocs/QuickDocs";

const SeoOnboardingDocs = () => {
  const [isOpen, setIsDocOpen] = React.useState(false);

  const toggleDocs = () => setIsDocOpen(prev => !prev);
  return (
    <>
      <Tag
        style={{ cursor: "pointer", borderRadius: "100px" }}
        color="blue"
        onClick={toggleDocs}
      >
        <InfoCircleOutlined /> onboarding
      </Tag>

      <QuickDocs
        title={"Paid Search Onboarding"}
        handleClick={toggleDocs}
        open={isOpen}
        onCancel={toggleDocs}
        onOk={toggleDocs}
      >
        <p>
          This documentation is a guide for channel partners who want to onboard
          their sub-organizations' SEO to a platform. By doing so, they can
          report on the SEO data on the dashboard.
        </p>

        <Divider orientation="left">Instructions</Divider>
        <Collapse size="small">
          <Collapse.Panel header="Google Analytics">
            <ol>
              <li>
                Grant admin access to{" "}
                <Typography.Link>
                  seosemadministrator@mediajel.com
                </Typography.Link>{" "}
                for your sub-org's Google Analytics container.
              </li>
              <li>
                Navigate to your sub-org's{" "}
                <Typography.Link href="\orgs">settings page</Typography.Link>
              </li>
              <li>
                Scroll down to find the <b>Data Config</b> section.
              </li>
              <li>
                Fill in the <b>ViewId</b> field with the correct Google
                Analytics Universal Analytics view id or GA4 view id.
              </li>
              <li>
                Adjust the switch to UA if you provided a Universal analytics
                view id or GA4 if you provided a GA4 view id.
              </li>
              <li>
                Enable the <b>SEO</b> switch
              </li>
              <li>Click on the Update button.</li>
            </ol>
          </Collapse.Panel>
        </Collapse>
        <br />
        <p>
          After following the instructions above, the platform will start
          consuming data from the paid search providers after 24 hours.
        </p>
      </QuickDocs>
    </>
  );
};

export default SeoOnboardingDocs;
